import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import routeConstant from "../../../../../route/compoent/routeConstant";
import orderObject from "../../../../constants/data/orderCreation";
// import routeConstant from "../../../../routes/utils/routeConstant";
import { StoreContext } from "../../../../store";
import ModalBox from "../../Modal/Index";

function Index(props) {
  const context = useContext(StoreContext);
  const navigate = useNavigate();
  return (
    <ModalBox title="Discard Message">
      <div className="_modalBody container-fluid">
        <div className="row ">
          <div className="col-12">
            <p style={{ textAlign: "left" }}>
              Are you sure you want to discard this order?
            </p>
          </div>
          <div className="col-12">
            <div className="_modalFooter justify-content-end">
              <div className="_outlineButton me-2">
                <button onClick={() => context.setModalOpen(false)}>
                  Cancel
                </button>
              </div>
              <div className="_solidButton">
                <button
                  //   to={routeConstant.CREATE_ORDER}
                  //   state={{
                  //     edit: false,
                  //   }}
                  onClick={() => {
                    context.setModalOpen(false);
                    context.setEditMode(false);
                    // props.setEdit("Create Order");
                    context.setOrderJSON({ ...orderObject });
                    navigate(routeConstant.CREATE_ORDER, {
                      state: {
                        edit: false
                      }
                    });
                  }}
                >
                  Discard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalBox>
  );
}

export default Index;
